import { EditorRepeatRenderManager } from './EditorRepeatRenderManager';

export const RepeatRenderModule = {
  __init__: ['repeatRenderManager'],
  repeatRenderManager: ['type', EditorRepeatRenderManager],
};

export { EditorRepeatRenderManager };
